import { IconButton } from "components/miloDesignSystem/atoms/iconButton";
import { MdiKeyboardTab } from "components/miloDesignSystem/atoms/icons/MdiKeyboardTab";
import { Tooltip } from "components/miloDesignSystem/atoms/tooltip";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { RightPanelHeader } from "components/utils/drawer";

interface Props {
  close: () => void;
  signature: string;
}

export const PanelHeader = ({ close, signature }: Props) => {
  return (
    <RightPanelHeader>
      <Typography fontSize="16" fontWeight="600">
        {signature}
      </Typography>
      <div className="d-flex align-items-center justify-content-end flex-1">
        <Tooltip title="Zamknij panel">
          <IconButton icon={MdiKeyboardTab} onClick={close} variant="blackT" />
        </Tooltip>
      </div>
    </RightPanelHeader>
  );
};
